<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Gérer les dispenses</h2>

        <b-col cols="10">

            <b-row class="pt-3 pb-3">
                <b-col>Cet onglet permet de dispenser un marché de reporting pour un ou plusieurs onglets, pour une
                    période donnée.
                </b-col>
            </b-row>

            <b-col>
                <b-row>
                    <b-col cols="4">
                        <b-form-group v-if="!isAdmin"
                                      id="input-group-marches"
                                      label="Marché" label-for="input-marches">
                            <b-form-select
                                    id="input-marches"
                                    v-model="marche"
                                    :options="marches"
                                    @change="search()"
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner un marché
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group v-if="isAdmin"
                                      id="input-group-marches" label-for="input-marches">
                            <template v-slot:label>
                                <label-custom
                                        label="Marché"
                                        :tooltip=libelles.infoBulleNumMarche>
                                </label-custom>
                            </template>
                            <AutocompleteCustom
                                    id="input-marches"
                                    :items="marcheIdsItems"
                                    v-model="marche"
                                    @search="onMarcheSearch"
                                    :placeholder=libelles.selectionnerMarche
                            >
                            </AutocompleteCustom>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group id="input-group-onglet"
                                      label="Onglet" label-for="input-onglet"
                        >
                            <b-form-select
                                    id="input-onglet"
                                    v-model="onglet"
                                    :options="onglets"
                                    @change="search()"
                            >
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col offset="1">
                        <b-row class="pt-4">
                            <b-button v-if="hide()" type="button" variant="success"
                                      @click="create">Enregistrer
                            </b-button>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4">
                        <b-form-group id="input-group-date-debut" label-for="input-date-debut">
                            <template v-slot:label>
                                <label-custom
                                        label="Date de début">
                                </label-custom>
                            </template>
                            <vue-monthly-picker
                                    id="input-date-debut"
                                    dateFormat="MM/YYYY"
                                    :monthLabels="monthLabels"
                                    v-model="dateDebut"
                            >
                            </vue-monthly-picker>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group id="input-group-date-fin" label-for="input-date-fin">
                            <template v-slot:label>
                                <label-custom
                                        label="Date de fin">
                                </label-custom>
                            </template>
                            <vue-monthly-picker
                                    id="input-date-fin"
                                    dateFormat="MM/YYYY"
                                    :monthLabels="monthLabels"
                                    v-model="dateFin"
                            >
                            </vue-monthly-picker>
                            <div class="typo-warning" v-if="isBeforeDate()">
                                la date de fin doit être postérieure à la date de début
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4">
                        <b-form-group id="input-group-types"
                                      label="Type" label-for="input-types">
                            <b-form-select
                                    id="input-types"
                                    v-model="types"
                                    @change="search">
                                <b-form-select-option
                                        :value="['ADMINISTRATEUR', 'UTILISATEUR']">
                                    Tous
                                </b-form-select-option>
                                <b-form-select-option :value="['ADMINISTRATEUR']">
                                    ADMINISTRATEUR
                                </b-form-select-option>
                                <b-form-select-option :value="['UTILISATEUR']">
                                    UTILISATEUR
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group id="input-group-commentaire"
                                      label="Commentaire" label-for="input-commentaire">
                                <b-form-input
                                        id="input-commentaire"
                                        v-model="commentaire"
                                        type="text"
                                        maxlength="200"
                                        :trim="true"
                                        >
                                </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="1" offset="3">
                      <b-button type="button" variant="success" @click="exporter">Exporter</b-button>
                    </b-col>
                </b-row>
            </b-col>
            <div v-if="reportingDispenseResult">
                <div class="overflow-auto">
                    <b-table striped hover fixed
                             :no-local-sorting="true"
                             :items="reportingDispenseTable" :fields="fields">
                        <template v-slot:cell(delete)="row">
                            <b-button size="sm" v-b-modal="'modal-delete' + row.item.id">
                                <Icon icon="trash" size="1x"></Icon>
                            </b-button>
                            <b-modal
                                    :id="'modal-delete' + row.item.id"
                                    title="Suppression de la dispense"
                                    ok-title="Confirmer"
                                    cancel-title="Annuler"
                                    @ok="supprimerDispense(row.item)">
                                <p>Confirmez-vous la suppression de cette dispense ?</p>
                            </b-modal>
                        </template>
                        <template v-slot:cell(edit)="row">
                          <b-button size="sm" v-b-modal="'modal-edit' + row.item.id">
                            <Icon icon="edit" size="1x"></Icon>
                          </b-button>
                          <b-modal
                                :id="'modal-edit' + row.item.id"
                                title="Modification de la dispense"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                hide-footer
                                @hidden="search"
                                @ok="preventOk">
                            <ModifierReportingDispenses
                                  :value="row.item"
                                  :modalId="'modal-edit' + row.item.id"
                            ></ModifierReportingDispenses>
                          </b-modal>
                        </template>
                    </b-table>
                </div>
            </div>
        </b-col>
    </div>

</template>

<script>
  import ReportingStore from "../../stores/ReportingStore";
  import ReportingSearchDto from "../../dtos/ReportingSearchDto";
  import DispenseReportingDto from "../../dtos/DispenseReportingDto";
  import AlertStore from "../../stores/AlertStore";
  import MarcheStore from "../../stores/MarcheStore";
  import SessionStore from '@/stores/SessionStore'
  import hasPermission from "../../filters/hasPermission";
  import VueMonthlyPicker from "vue-monthly-picker";
  import {mois} from "../../constants/enums";
  import LabelCustom from "../../components/LabelCustom";
  import AutocompleteCustom from "../../components/AutocompleteCustom";
  import moment from 'moment';
  import {momentToDate} from "../../utils/dateUtil";
  import _ from 'lodash';
  import {libelles} from "../../constants/libelles";
  import ModifierReportingDispenses from "@/views/reporting/ModifierReportingDispenses";
  import FileUtil from "@/utils/fileUtil";

  export default {
    components: {
      VueMonthlyPicker,
      LabelCustom,
      AutocompleteCustom,
      ModifierReportingDispenses
    },
    data() {
      return {
        sessionStoreState: SessionStore.state,
        marche: null,
        marches: [],
        reportingDispenseResult: null,
        onglet: 'Tous',
        adminOnglets: ['EMPREINTE', 'EFFECTIFS', 'ACCIDENTOLOGIE', 'GPEC_PREVISIONNEL', 'GPEC_REALISE'],
        gpecOnglets: ['GPEC_PREVISIONNEL', 'GPEC_REALISE'],
        dateDebut: null,
        dateFin: null,
        monthLabels: mois,
        types: ['ADMINISTRATEUR', 'UTILISATEUR'],
        commentaire:"",
        libelles: libelles,
        marcheIdsItems: [],
        marchesAdmin: [],
      }
    },
    watch: {
      marche() {
        this.search();
      }
    },
    computed: {
      isAdmin() {
        return hasPermission(['ADMINISTRATEUR']);
      },
      fields() {
        return [
          {label: 'Référence marché', key: 'referenceMarche'},
          {label: 'Libellé court marché', key: 'libelleCourtMarche'},
          {label: 'Onglet', key: 'ongletReporting'},
          {label: 'Type', key: 'type'},
          {label: 'Date de début', key: 'dateDebut'},
          {label: 'Date de fin', key: 'dateFin'},
          {label: 'Commentaire', key: 'commentaire'},
          {label: 'Consulter / Modifier', key: 'edit', sortable: false},
          {label: 'Supprimer', key: 'delete'}
        ];
      },
      reportingDispenseTable: function () {
        return this.reportingDispenseResult.map(reportingDispense => {
          return {
            id: reportingDispense.id,
            marche: reportingDispense.marche,
            referenceMarche: reportingDispense.marche.reference,
            libelleCourtMarche: reportingDispense.marche.libelleCourt,
            ongletReporting: reportingDispense.ongletReporting,
            dateDebut: moment(reportingDispense.dateDebut).format('DD/MM/YYYY'),
            dateFin: moment(reportingDispense.dateFin).format('DD/MM/YYYY'),
            commentaire:reportingDispense.commentaire,
            type: reportingDispense.type,
          }
        });
      },
      onglets() {
        if (hasPermission(['ADMINISTRATEUR'])) {
          return ['Tous'].concat(this.adminOnglets);
        }
        let onglets = [];
        if (hasPermission(['CORRESPONDANT_GPEC_ADMINISTRATEUR'])) {
          onglets = onglets.concat(['Tous GPEC'].concat(this.gpecOnglets));
        }
        if (hasPermission(['CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'])) {
          onglets.push('EMPREINTE');
        }
        if (hasPermission(['CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'])) {
          onglets.push('EFFECTIFS');
        }
        if (hasPermission(['CORRESPONDANT_SECURITE_ADMINISTRATEUR'])) {
          onglets.push('ACCIDENTOLOGIE');
        }
        return onglets;
      }
    },
    mounted() {
      if (hasPermission(['CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'])) {
        this.onglet = 'EMPREINTE'
      }
      if (hasPermission(['CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'])) {
        this.onglet = 'EFFECTIFS'
      }
      if (hasPermission(['CORRESPONDANT_SECURITE_ADMINISTRATEUR'])) {
        this.onglet = 'ACCIDENTOLOGIE'
      }
      if (hasPermission(['CORRESPONDANT_GPEC_ADMINISTRATEUR'])) {
        this.onglet = 'Tous GPEC'
      }
      if (hasPermission(['ADMINISTRATEUR'])) {
        MarcheStore.getAll().then(marches => {
          this.marches = marches;
          this.marchesAdmin = marches.map(marche => {
            return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche};
          });
          this.marcheIdsItems = this.marchesAdmin;
        });
      } else {
        this.marches = this.sessionStoreState.marches.map(marche => {
          return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche};
        });
      }
      this.search();
    },
    methods: {
      onFilterChange: _.debounce(function () {
        this.search();
      }, 1000),
      search() {
        const reporting = this.getSearchDispense();
        ReportingStore.searchDispenses(reporting).then(
            result => {
              this.reportingDispenseResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      createDispense(onglet) {
        const reportingDispense = new DispenseReportingDto();
        reportingDispense.marche = this.marche;
        reportingDispense.ongletReporting = onglet;
        reportingDispense.dateDebut = momentToDate(this.dateDebut);
        reportingDispense.dateFin = momentToDate(this.dateFin);
        reportingDispense.type = this.types[0];
        reportingDispense.commentaire = this.commentaire;
        return reportingDispense;
      },
      create() {
        let promises = [];
        let onglets = [];
        if (this.onglet === 'Tous') {
          onglets = this.adminOnglets;
        } else if (this.onglet === 'Tous GPEC') {
          onglets = this.gpecOnglets;
        } else {
          onglets.push(this.onglet);
        }
        for (const onglet of onglets) {
          const reportingDispense = this.createDispense(onglet);
          promises.push(ReportingStore.create(reportingDispense));
        }
        Promise.all(promises).then(() => {
          this.search();
        });
      },
      supprimerDispense(dispense) {
        ReportingStore.delete(dispense).then(() => {
          this.search();
        });
      },
      getSearchDispense() {
        const reporting = new ReportingSearchDto();
        reporting.marcheId = this.marche ? this.marche.id : null;
        reporting.onglets = (hasPermission(['CORRESPONDANT_GPEC_ADMINISTRATEUR']) && this.onglet === 'Tous GPEC') ? this.gpecOnglets : ((hasPermission(['ADMINISTRATEUR']) && this.onglet === 'Tous') ? this.adminOnglets : [this.onglet]);
        reporting.types = this.types;
        return reporting;
      },
      isBeforeDate() {
        if (this.dateDebut && this.dateFin) {
          return this.dateFin.isBefore(this.dateDebut)
        }
        return false;
      },
      hide() {
        return (this.marche && this.onglet && this.dateDebut && this.dateFin && !this.isBeforeDate() && this.types.toString() === "ADMINISTRATEUR");
      },
      onMarcheSearch(marche, isId) {
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marchesAdmin)
      },
      preventOk(evt) {
        evt.preventDefault();
      },
      exporter() {
        const reporting = this.getSearchDispense();
        ReportingStore.exportDispenses(reporting).then(
            result => {
              FileUtil.downloadFile(result.data, 'text/csv;charset=utf8;');
            },
            error => AlertStore.pushError(error.response.data.message)
        );
      }
    }
  }
</script>
